import { Select } from "antd";
import styled, { createGlobalStyle } from "styled-components";

export const SSGlobalStyle = createGlobalStyle`
    .markets-sort-popup {
        width: 200px !important;
        
        .ant-select-item {
            min-height: auto;
        }

        .ant-select-item-option-content {
            font-weight: 500;
            font-size: 14px;
            line-height: 120%;
            padding: 12px;
        }

        .rc-virtual-list-holder {
            max-height: 320px;
        }
    }
`;

export const StyledSSSortWrapper = styled(Select)`
    min-height: 44px !important;
    max-height: 44px !important;
    min-width: 44px !important;
    max-width: 44px !important;
    .ant-select-selection-item {
        display: none !important;
    }

    .ant-select-selector {
        padding: 10px !important;
        width: fit-content;
    }

    .ant-select-dropdown {
        background-color: red !important;
    }

    .ant-select-single {
    }
`;

export const StyledSSSortIcon = styled.img`
    width: 24px;
    height: 24px;
    pointer-events: none !important;
`;
